/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceInfoRequest } from './DeviceInfoRequest';
import {
    DeviceInfoRequestFromJSON,
    DeviceInfoRequestFromJSONTyped,
    DeviceInfoRequestToJSON,
    DeviceInfoRequestToJSONTyped,
} from './DeviceInfoRequest';
import type { SubscriptionTier } from './SubscriptionTier';
import {
    SubscriptionTierFromJSON,
    SubscriptionTierFromJSONTyped,
    SubscriptionTierToJSON,
    SubscriptionTierToJSONTyped,
} from './SubscriptionTier';
import type { CompassInfoRequest } from './CompassInfoRequest';
import {
    CompassInfoRequestFromJSON,
    CompassInfoRequestFromJSONTyped,
    CompassInfoRequestToJSON,
    CompassInfoRequestToJSONTyped,
} from './CompassInfoRequest';
import type { UserInfo } from './UserInfo';
import {
    UserInfoFromJSON,
    UserInfoFromJSONTyped,
    UserInfoToJSON,
    UserInfoToJSONTyped,
} from './UserInfo';
import type { CompassSettingsRequest } from './CompassSettingsRequest';
import {
    CompassSettingsRequestFromJSON,
    CompassSettingsRequestFromJSONTyped,
    CompassSettingsRequestToJSON,
    CompassSettingsRequestToJSONTyped,
} from './CompassSettingsRequest';
import type { ConnectionStatus } from './ConnectionStatus';
import {
    ConnectionStatusFromJSON,
    ConnectionStatusFromJSONTyped,
    ConnectionStatusToJSON,
    ConnectionStatusToJSONTyped,
} from './ConnectionStatus';
import type { UserLocationRequest } from './UserLocationRequest';
import {
    UserLocationRequestFromJSON,
    UserLocationRequestFromJSONTyped,
    UserLocationRequestToJSON,
    UserLocationRequestToJSONTyped,
} from './UserLocationRequest';

/**
 * 
 * @export
 * @interface UserStatusPing
 */
export interface UserStatusPing {
    /**
     * 
     * @type {string}
     * @memberof UserStatusPing
     */
    user_auth_id: string;
    /**
     * 
     * @type {number}
     * @memberof UserStatusPing
     */
    timestamp: number;
    /**
     * 
     * @type {ConnectionStatus}
     * @memberof UserStatusPing
     */
    connection_status: ConnectionStatus;
    /**
     * 
     * @type {UserLocationRequest}
     * @memberof UserStatusPing
     */
    location?: UserLocationRequest;
    /**
     * 
     * @type {UserInfo}
     * @memberof UserStatusPing
     */
    user_info: UserInfo;
    /**
     * 
     * @type {DeviceInfoRequest}
     * @memberof UserStatusPing
     */
    device_info?: DeviceInfoRequest;
    /**
     * 
     * @type {CompassSettingsRequest}
     * @memberof UserStatusPing
     */
    compass_settings?: CompassSettingsRequest;
    /**
     * 
     * @type {CompassInfoRequest}
     * @memberof UserStatusPing
     */
    compass_info?: CompassInfoRequest;
    /**
     * 
     * @type {SubscriptionTier}
     * @memberof UserStatusPing
     */
    effective_tier?: SubscriptionTier;
}



/**
 * Check if a given object implements the UserStatusPing interface.
 */
export function instanceOfUserStatusPing(value: object): value is UserStatusPing {
    if (!('user_auth_id' in value) || value['user_auth_id'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('connection_status' in value) || value['connection_status'] === undefined) return false;
    if (!('user_info' in value) || value['user_info'] === undefined) return false;
    return true;
}

export function UserStatusPingFromJSON(json: any): UserStatusPing {
    return UserStatusPingFromJSONTyped(json, false);
}

export function UserStatusPingFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserStatusPing {
    if (json == null) {
        return json;
    }
    return {
        
        'user_auth_id': json['user_auth_id'],
        'timestamp': json['timestamp'],
        'connection_status': ConnectionStatusFromJSON(json['connection_status']),
        'location': json['location'] == null ? undefined : UserLocationRequestFromJSON(json['location']),
        'user_info': UserInfoFromJSON(json['user_info']),
        'device_info': json['device_info'] == null ? undefined : DeviceInfoRequestFromJSON(json['device_info']),
        'compass_settings': json['compass_settings'] == null ? undefined : CompassSettingsRequestFromJSON(json['compass_settings']),
        'compass_info': json['compass_info'] == null ? undefined : CompassInfoRequestFromJSON(json['compass_info']),
        'effective_tier': json['effective_tier'] == null ? undefined : SubscriptionTierFromJSON(json['effective_tier']),
    };
}

export function UserStatusPingToJSON(json: any): UserStatusPing {
    return UserStatusPingToJSONTyped(json, false);
}

export function UserStatusPingToJSONTyped(value?: UserStatusPing | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_auth_id': value['user_auth_id'],
        'timestamp': value['timestamp'],
        'connection_status': ConnectionStatusToJSON(value['connection_status']),
        'location': UserLocationRequestToJSON(value['location']),
        'user_info': UserInfoToJSON(value['user_info']),
        'device_info': DeviceInfoRequestToJSON(value['device_info']),
        'compass_settings': CompassSettingsRequestToJSON(value['compass_settings']),
        'compass_info': CompassInfoRequestToJSON(value['compass_info']),
        'effective_tier': SubscriptionTierToJSON(value['effective_tier']),
    };
}

